let ALWAYS_ON = ['Calendar', 'Comms']

export function canBeClosed(type) {
  return !ALWAYS_ON.includes(type)
}
